const {
  runStringExtender: baseRunStringExtender
} = require('vue-js-extender');

const _jsExtensionCache = {
  String: {
    replaceTypes: ["string", "regexp"],
    toEscapeChars: ['.', '?', '|']
  }
};

exports.runStringExtender = (Vue) => {
  baseRunStringExtender(Vue);

  //------------------------- String Extensions -------------------------
  String.prototype.toHtml = String.prototype.toHtml || function() {
    return this.replaceAll(" ", "&nbsp;").replaceAll("\r\n", "<br/>").replaceAll("\r", "<br/>").replaceAll("\n", "<br/>");
  };
  String.toHtml = String.toHtml || function (target, ...args) {
    if (Object.typeOf(target) !== "string")
      throw new Error("target is not a string.");

    return target.toHtml.apply(target, args);
  };
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/string.extender.js